<div class="widget-frame" #widgetFrame>
    @if (!config.customConfig.hideHeader) {
        <div class="title">
            @let widgetTitle =
                config.customConfig.customTitle
                    ? config.customConfig.customTitle
                    : (config.title | transloco);
            <div class="name" [matTooltip]="widgetTitle">
                <cerrix-icon-viewer
                    [icon]="
                        config.customConfig.customIcon
                            ? config.customConfig.customIcon
                            : config.icon
                    "
                    appendClass="me-2"
                ></cerrix-icon-viewer>
                <span>{{ widgetTitle }}</span>
            </div>
            <div class="filler"></div>
            @if (config.hasGlobalOpen) {
                <div class="actions">
                    <i class="fas fa-external-link" (click)="config.api.onGlobalOpenClick()"></i>
                </div>
            }
        </div>
    }
    <div
        class="widget-content"
        [class.hide-overflow]="config.showLoader || config.noData || unauthorized"
    >
        @if (config.showLoader) {
            <div
                class="fancy-loader submodule"
                [class.sm]="
                    config.customConfig.gridsterConfig.rows < 2 ||
                    config.customConfig.gridsterConfig.cols < 2
                "
                [class.md]="
                    config.customConfig.gridsterConfig.rows < 3 ||
                    config.customConfig.gridsterConfig.cols < 3
                "
            ></div>
        }
        @if (config.noData) {
            <div class="nodata-message">
                @if (config.noDataExplanation) {
                    <span>{{ config.noDataExplanation }}</span>
                } @else {
                    <span>{{ "dashboard.dashboardWidget.noDataMessage" | transloco }}</span>
                }
            </div>
        }

        @if (unauthorized) {
            <div class="unauthorized-message">
                @if (config.customConfig.gridsterConfig.rows > 1) {
                    <i class="far fa-chart-bar"></i>
                }
                <span>{{ "dashboard.dashboardWidget.unauthorizedMessage" | transloco }}</span>
            </div>
        }
        <ng-template #widgetContainer></ng-template>
    </div>
</div>
